module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7SMI0"))).then(() => parcelRequire('fThBo'));